import { render } from "./CustomerServiceButton.vue?vue&type=template&id=1af6e298&scoped=true"
import script from "./CustomerServiceButton.vue?vue&type=script&lang=js"
export * from "./CustomerServiceButton.vue?vue&type=script&lang=js"

import "./CustomerServiceButton.vue?vue&type=style&index=0&id=1af6e298&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1af6e298"]])

export default __exports__